import { createSelector } from '@ngrx/store';
import { IBankState } from './bank.reducer';

const bankStore = (state: any) => state.bank as IBankState;
export const selectBankLista = createSelector(
  bankStore,
  (state) => state.lista
);
